import React from "react";
import {
    Button,
    ButtonGroup,
    Dialog,
    DialogActions,
    DialogContent,
    DialogContentText,
    DialogTitle,
    TextField,
} from "@mui/material";
import { deleter } from "../../../functions/axios";

export default function DialogDelete(props) {
    const handleDeletion = () => {
        const url = `delete?id=${props.id}`;
        deleter(url).then((response) => {
            if (response.status === 200) {
                props.handleDelete();
            }
            props.onClose();
        });
    };

    const [verificationValue, setVerificationValue] = React.useState("");

    return (
        <Dialog
            open={props.open}
            keepMounted
            onClose={props.onClose}
            aria-describedby="alert-dialog-slide-description"
        >
            <DialogTitle>Delete QR code</DialogTitle>
            <DialogContent>
                <DialogContentText id="alert-dialog-slide-description">
                    Are you sure you wish to delete QR code "{props.title}"? This will break all existing links to this QR code and cannot be undone.
                    <br />
                    Type the name of the QR code to confirm deletion:
                </DialogContentText>
            </DialogContent>
            <DialogActions>
                <TextField
                    autoFocus
                    id="name"
                    type="text"
                    value={verificationValue}
                    onChange={(e) => setVerificationValue(e.target.value)}
                    fullWidth
                    variant="standard"
                />
                <ButtonGroup variant="contained">
                    <Button onClick={props.onClose}>Cancel</Button>
                    <Button onClick={handleDeletion} color="error" disabled={props.title !== verificationValue}>Delete</Button>
                </ButtonGroup>
            </DialogActions>
        </Dialog>
    );
}
